import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
import { MessageContent } from './message-content';
export var Message = /*#__PURE__*/function (_Entity) {
  _inherits(Message, _Entity);

  var _super = _createSuper(Message);

  function Message() {
    _classCallCheck(this, Message);

    return _super.apply(this, arguments);
  }

  _createClass(Message, [{
    key: "conversationId",
    get: function get() {
      return this.props.conversationId;
    }
  }, {
    key: "role",
    get: function get() {
      return this.props.role;
    }
  }, {
    key: "status",
    get: function get() {
      return this.props.status;
    }
  }, {
    key: "content",
    get: function get() {
      return this.props.content;
    }
  }, {
    key: "data",
    get: function get() {
      return this.props.data;
    }
  }, {
    key: "userId",
    get: function get() {
      return this.props.userId;
    }
  }, {
    key: "modelId",
    get: function get() {
      return this.props.modelId;
    }
  }, {
    key: "fileIds",
    get: function get() {
      return this.props.fileIds;
    }
  }, {
    key: "tokenUsed",
    get: function get() {
      return this.props.tokenUsed;
    }
  }, {
    key: "cost",
    get: function get() {
      return this.props.cost;
    }
  }, {
    key: "createdTime",
    get: function get() {
      return this.props.createdTime;
    }
  }, {
    key: "updateContent",
    value: function updateContent(content) {
      var guardResult = Guard.againstStringNullOrEmpty(content, 'Content');

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Invalid content');
      }

      this.props.content = MessageContent.create(content).getValue();
      return Result.ok(this);
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(status) {
      this.props.status = status;
      return Result.ok(this);
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, {
        argument: props.status,
        argumentName: 'Status'
      }, {
        argument: props.conversationId,
        argumentName: 'ConversationId'
      }, {
        argument: props.role,
        argumentName: 'Role'
      }, {
        argument: props.content,
        argumentName: 'Content'
      }, {
        argument: props.createdTime,
        argumentName: 'CreatedTime'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message2;

        return Result.fail((_guardResult$message2 = guardResult.message) !== null && _guardResult$message2 !== void 0 ? _guardResult$message2 : 'Invalid message props');
      }

      var message = new Message(props, new UniqueEntityID(props.id));
      return Result.ok(message);
    }
  }]);

  return Message;
}(Entity);